import axios from 'axios';
import { Ferramenta, ModalidadeParticipante } from 'enum';
import { AssociadoType } from 'models/associado';
import {
  AgenciaCooperativa,
  AgenciaPorCooperativaResponse,
  Cooperativa,
  Evento,
  ParticipanteNaoAssociado,
} from 'models/naoAssociado';
import { toRequest } from 'utils/RequestUtils';
import { getBackofficeEndpoint } from './Endpoints';

export const api = axios.create();
export type ApiErrorType = { errors: string[]; code?: number };

export const buscarCPF = (
  reCaptchaToken: string,
  captchaVersion: '2' | '3',
  cpf: string,
  idEvento?: number | string,
  ferramenta?: Ferramenta,
  modalidade?: ModalidadeParticipante
) => {
  const url = `${getBackofficeEndpoint()}/registrar`;
  return toRequest<void | AssociadoType>(api.post, [
    url,
    { cpf, idTurma: idEvento, system: Ferramenta[ferramenta!], modalidade },
    { headers: { reCaptchaToken, captchaVersion } },
  ]);
};

export const confirmarPresencaAssociado = (
  reCaptchaToken: string,
  captchaVersion: string,
  usuario: AssociadoType,
  modalidade?: ModalidadeParticipante,
  ferramenta?: Ferramenta
) => {
  const url = `${getBackofficeEndpoint()}/registrar/associado`;
  return toRequest<void>(api.post, [
    url,
    { ...usuario, system: Ferramenta[ferramenta!], modalidade },
    { headers: { reCaptchaToken, captchaVersion } },
  ]);
};

export const obterDadosEvento = (idEvento?: number, system?: string) => {
  const url = `${getBackofficeEndpoint()}/evento/${idEvento}?system=${system}`;
  return axios.get<Evento>(url);
};

export const salvarParticipanteNaoAssociado = (
  reCaptchaToken: string,
  captchaVersion: string,
  participante: ParticipanteNaoAssociado
) => {
  const url = `${getBackofficeEndpoint()}/registrar/nao-associado`;
  return toRequest<void | AssociadoType>(api.post, [
    url,
    participante,
    { headers: { reCaptchaToken, captchaVersion } },
  ]);
};

export const getUrlCrescerNaPratica = () => {
  const url = `${getBackofficeEndpoint()}/crescer-na-pratica`;
  return toRequest<string>(api.get, [url]);
};

export const getUrlNossoNegocioCoop = () => {
  const url = `${getBackofficeEndpoint()}/nosso-negocio-cooperativista`;
  return toRequest<string>(api.get, [url]);
};

export const getCooperativas = async () => {
  const url = `${getBackofficeEndpoint()}/evento/cooperativas`;
  return (await axios.get<Cooperativa[]>(url)).data;
};

export const getAgenciasPorCooperativa = async (
  codCooperativa: string | number
) => {
  const url = `${getBackofficeEndpoint()}/evento/agencias/coop/${codCooperativa}`;
  return (await axios.get<AgenciaPorCooperativaResponse[]>(url)).data;
};

export const getAgenciaPorCep = async (cep: string | number) => {
  const url = `${getBackofficeEndpoint()}/evento/entidades-proxima/${cep}`;
  return (await axios.get<AgenciaCooperativa>(url)).data;
};
